export const columns = [
  {
    title: "#",
    dataIndex: "index",
    width: 60,
    slots: { customRender: "index" },
  },
  {
    title: "材料编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "材料名称",
    width: 200,
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    dataIndex: "materialModel",
    key: "materialModel",
  },
  {
    title: "品牌",
    width: 100,
    dataIndex: "materialBrand",
    key: "materialBrand",
  },
  {
    title: "结算单位",
    width: 100,
    dataIndex: "materialUnit",
    key: "materialUnit",
  },
  {
    width: 180,
    slots: { title: "materialCategoryTitle", customRender: "materialCategoryId" },
  },
];
